import {Component, OnInit} from '@angular/core';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {DictionaryService, TableService, UserService, VisitedService} from '@amlCore/services';
import {ActivatedRoute, Router} from '@angular/router';
import {RegistriesAccessEnum} from '@amlCore/enums';
import {AccessJson} from '@amlCore/models';
import {BankServiceGroupModel, BankServiceModel} from "../../model/bankService.model";
import {BankServiceService} from "./bankService.service";
import {IDictItemType} from "@amlCore/interfaces";
import {RiskAccessEnum} from "../../../core/enum/riskAccessEnum";

@Component({
  selector: 'app-bankservice-list',
  templateUrl: './bankServiceList.component.html'
})
export class BankServiceListComponent extends TableReactiveUrlController implements OnInit {
  params: any;
  isShowVisited = true;
  protected bankServiceGroupList: BankServiceGroupModel[] = [];
  protected risklevelList: IDictItemType[] = [];
  access: AccessJson;

  constructor(protected readonly activatedRoute: ActivatedRoute,
              protected readonly visitedService: VisitedService,
              protected readonly tableService: TableService,
              protected readonly router: Router,
              protected readonly bankServiceService: BankServiceService,
              private readonly usersService: UserService,
              protected dictSrv: DictionaryService) {
    super(router, activatedRoute, visitedService, tableService, {});
  }

  ngOnInit(): void {
    this.access = this.usersService.getAccess(RiskAccessEnum.RISK_SERVICES);
    this.activatedRoute.queryParams.subscribe((data) => {
      this.loadList(data);
    });
    this.dictSrv.getRemoteData('risklevel').then((result) => {
      this.risklevelList = result;
    });
  }

  loadList(params?: any): void {
    this.bankServiceService.getList(params).subscribe(data => {
      this.bankServiceGroupList = data;
      this.bankServiceGroupList.push(this.bankServiceGroupList.splice(1, 1)[0]);
      this.total = data.length;
      this.scrollRun();
    });
  }

  open(data: BankServiceModel): void {
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate([`/registries/bankService/${data.id}`]);
    this.saveRowId(data.id);
  }

  bankServiceGroupName(code: string) {
    return this.dictSrv.getStaticDataValue('bankServiceType', code);
  }

  riskLevelName(code: string) {
    return this.dictSrv.getDictNameByCode(code, this.risklevelList);
  }

  public getFilterObject(filter: any) {
    return filter;
  }

  onPageChange(params: any): void {
  }
}
